export const metrikaID = 88796460;

export const QuizQuestions = [
  {
    text:
      "На этом коллаже собраны 5000 изображений, которые художник Beeple " +
      "рисовал каждый день в течении почти четырнадцати лет, и это одно из трех самых дорогих " +
      "произведений ныне живущих художников. Сколько оно стоит?",

    range: {
      min: 10,
      max: 100,
      step: 1,
      dimMin: " млн $",
      dimMax: " млн $",
      dimChange: false,
    },
    answer: {
      min: 65,
      max: 75,

      value: 69.3,

      text:
        "Перед покупкой криптоарта стоит получше узнать историю продаж художника," +
        "его творчество, количество подписчиков в соцсетях. Автор коллажа Beeple —" +
        "один из самых известных диджитал-художников в мире, его работы продаются сотнями " +
        "на аукционах и перепродаются ещё дороже. Интерес к авторам произведений может " +
        "обезопасить вас от обмана или покупки фейковых картин.",
    },

    image: {
      src: "r1.png",
      srcSet: "step-0@2x.png",
    },
  },

  {
    text:
      "Похожие изображения с обезьянами уже приобрели Джастин Бибер, Мадонна, " +
      "Шакил О’Нил, а владельцем именно этого стал Eminem. Сколько он мог за него заплатить?",

    range: {
      min: 0.1,
      max: 1,
      step: 0.1,
      dimMin: " тыс $",
      dimMax: " млн $",
      dimChange: true,
    },
    answer: {
      min: 0.4,
      max: 0.5,

      value: 0.466,

      text:
        "Такие аватарки вошли в коллекцию «Bored Ape Yacht Club», самую дорогую и известную на данный" +
        " момент. Она же оказалась в центре скандала, когда злоумышленник взломал один из аккаунтов" +
        " авторов в соцсетях. Он разослал подписчикам ссылку на фишинговый сайт, предложив бесплатно" +
        " раздать им токены для новой метавселенной, однако на самом деле собрал данные кошельков" +
        " и украл с них NFT на 3 миллиона долларов.",
    },

    image: {
      src: "step-1.png",
      srcSet: "step-1@2x.png",
    },
  },

  {
    text:
      "100 таких изображений камня входили в одну из первых проданных" +
      " NFT-коллекций. За 5 лет его цена поднялась до…",

    range: {
      min: 0.2,
      max: 2,
      step: 0.1,
      dimMin: " тыс $",
      dimMax: " млн $",
      dimChange: true,
    },
    answer: {
      min: 1,
      max: 1.4,

      value: 1.2,

      text:
        "Перед любой покупкой NFT необходимо удостовериться в том, что площадка аукциона заслуживает" +
        " доверия. Иногда в смарт-контрактах даже крупных площадок могут находиться уязвимости и ошибки," +
        " которыми пользуются хакеры для кражи токенов. Участники конкурса " +
        "<a onclick=\"ym(88796460,'reachGoal','standoff_1'); return true;\" " +
        "href='https://standoff365.com/news/kiber-art-proverili-na-prochnost-on-ne-ustoyal/?utm_source=afisha-landing&utm_medium=link&utm_campaign=phd-11-nft' target='_blank'>The Standoff Digital Art</a>" +
        " на кибербитве <a onclick=\"ym(88796460,'reachGoal','standoff_1'); return true;\" " +
        "href='https://standoff365.com/?utm_source=afisha-landing&utm_medium=link&utm_campaign=phd-11-nft' target='_blank'>The Standoff</a> " +
        "в ноябре занимались именно этим и успешно взломали исходный код 6" +
        " реальных NFT-произведений — впрочем, от их действий не пострадал ни один криптоэнтузиаст.",
    },

    image: {
      src: "step-2.png",
      srcSet: "step-2@2x.png",
    },
  },

  {
    text:
      "На изображении представлен умник, который щелкает мышкой по каждой" +
      " картинке в этом тесте, сохраняет ее себе и считает, что переиграл всех" +
      " серьезных инвесторов. Snoop Dogg оценил юмор и приобрел эту работу за…",

    range: {
      min: 1,
      max: 10,
      step: 1,
      dimMin: " млн $",
      dimMax: " млн $",
      dimChange: false,
    },
    answer: {
      min: 6,
      max: 8,

      value: 7,

      text:
        "Некоторые злоумышленники просто продают чужие работы на аукционах. Чтобы" +
        " обезопасить себя от покупки фейка, стоит проверить историю покупок и продаж" +
        " владельца токена, а также поискать в сети, не постили ли такую работу где-то ещё." +
        " Если вы автор и у вас украли работу, можно пожаловаться модераторам платформы" +
        " на нарушение копирайта.",
    },

    image: {
      src: "step-3.png",
      srcSet: "step-3@2x.png",
    },
  },

  {
    text:
      "Год назад Хаски снял ролик  «Каша из топора» и продал на NFT-аукционе." +
      " В его версии сказка о хитром солдате и жадной хозяйке превратилась в" +
      " трагичный кулинарный блог. Сколько могло стоить такое видео?",

    range: {
      min: 1,
      max: 10,
      step: 1,
      dimMin: " тыс $",
      dimMax: " тыс $",
      dimChange: false,
    },
    answer: {
      min: 3,
      max: 4,

      value: 3.7,

      text:
        "Хотя россияне пока не ставят рекордов по продажам NFT, наша страна — лидер по числу жертв" +
        " мошенничества с криптовалютами, на нашу страну <a href='https://www.kommersant.ru/doc/5216108' target='_blank'>приходится</a>" +
        " более 11% пострадавших от краж." +
        " Поэтому стоит знать, как обезопасить себя от воровства. Если на имейл и в мессенджерах пришла" +
        " сомнительная ссылка, не переходите по ней и не вводите на подозрительных ресурсах учетные" +
        " данные и другие важные сведения. Если вас просят принять решение как можно скорее и не дают" +
        " убедиться в достоверности информации, то, вероятно, с вами общается мошенник.",
    },

    image: {
      src: "step-4.png",
      srcSet: "step-4@2x.png",
    },
  },

  {
    text:
      "Вы можете не узнать эту утку из блокчейн-игры, зато наверняка догадались," +
      " что автором этого изображения был Покрас Лампас." +
      " Во сколько оцените «Удачу и мудрость»?",

    range: {
      min: 10,
      max: 100,
      step: 1,
      dimMin: " тыс $",
      dimMax: " тыс $",
      dimChange: false,
    },
    answer: {
      min: 50,
      max: 60,

      value: 55,

      text:
        "Создавая кошелек для приобретения даже самых дешевых NFT, лучше включить многофакторную" +
        " авторизацию и придумать себе сложный и длинный пароль, например выбрать цитату из любимой" +
        " песни, разбавить ее знаками препинания, а некоторые буквы в словах сделать большими. Также" +
        " ни в коем случае не храните ваши секретные фразы и закрытые ключи в сети или менеджерах" +
        " паролей — лучше на бумаге и в безопасном месте.",
    },

    image: {
      src: "step-5.png",
      srcSet: "step-5@2x.png",
    },
  },

  {
    text:
      "В 2014 художник Кевин Маккой написал программу, которая бы случайно" +
      " генерировала изображения вот таких восьмиугольников, и привязал к ней токен" +
      " на свое имя. 7 лет спустя ее продали как самый первый NFT за…",

    range: {
      min: 0.5,
      max: 5,
      step: 0.1,
      dimMin: " тыс $",
      dimMax: " млн $",
      dimChange: true,
    },
    answer: {
      min: 1,
      max: 2,

      value: 1.47,

      text:
        "Именно эту продажу NFT сейчас оспаривают в суде. Хотя Маккой создал токен на свое имя" +
        " в блокчейне NameCoin в 2014-м, с тех пор не обновлял его и для аукциона сделал копию на базе" +
        " Ethereum. В пользовательском соглашении с владельцами NameCoin сказано, что все" +
        " неподтвержденные объекты собственности переходят в их распоряжение, и они успели продать" +
        " работу МакКоя третьей стороне, которая сейчас пытается доказать право на владение.",
    },

    image: {
      src: "step-6.png",
      srcSet: "step-6@2x.png",
    },
  },

  {
    text:
      "Основатель Twitter Джек Дорси продал скриншот самого первого твита" +
      " в соцсети на NFT-аукционе за 2,9 миллиона долларов. Когда токен выставили" +
      " на торги ещё раз, за него предложили намного меньше — …",

    range: {
      min: 1,
      max: 10,
      step: 0.1,
      dimMin: " тыс $",
      dimMax: " тыс $",
      dimChange: false,
    },
    answer: {
      min: 6,
      max: 8,

      value: 6.8,

      text:
        "Выставляя свой токен на продажу, убедитесь в правильности введенных данных, особенно" +
        " запрашиваемой цены и криптовалюты, ведь транзакцию нельзя отменить и вернуть деньги." +
        " Например, один из владельцев редкого токена «Bored Ape Yacht Club» случайно выставил его" +
        " на продажу за 3000 долларов вместо 300 000 — и тут же потерял свой NFT" +
        " из-за бота-снайпера.",
    },

    image: {
      src: "step-7.png",
      srcSet: "step-7@2x.png",
    },
  },

  {
    text:
      "Вопрос с подвохом! Во сколько вы оцените эту работу, проданную" +
      " с сайта художника Бэнкси?",

    range: {
      min: 0,
      max: 10,
      step: 0.1,
      dimMin: " тыс $",
      dimMax: " тыс $",
      dimChange: false,
    },
    answer: {
      min: 0,
      max: 0,

      value: 0,

      text:
        "На самом деле это изображение не имеет никакого отношения к Бэнкси. Хакер лишь взломал" +
        " его сайт и через него организовал торги с поклонниками анонимного артиста. Ему удалось" +
        " выручить за нее 336 тысяч долларов, но, когда обман вскрылся, злоумышленник вернул" +
        " деньги покупателю.",
    },

    image: {
      src: "step-8.png",
      srcSet: "step-8@2x.png",
    },
  },
];
